<dashboardnav>

  <cradua-file-location
  [filelocations]="filelocations$ | async"
  (filelocation)="onSubmitFileLocation($event)"
  (deleteFileLocationEvent)="onDeleteFileLocation($event)"
  *ngIf="(isLoadingFileLocation$ | async ) === false"
  >
</cradua-file-location>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingFileLocation$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
